import React from 'react';

/**
 * Fallback block — renders a minimal placeholder card with the block's
 * heading-ish text so the page is at least navigable. Used for block_types
 * we haven't fully implemented yet.
 */
function StubBlock({ data = {}, blockType = 'block' }) {
  const title =
    data.heading ||
    data.title ||
    [data.heading_prefix, data.heading_highlight, data.heading_suffix]
      .filter(Boolean)
      .join('') ||
    blockType;

  return (
    <section className="py-12 bg-white">
      <div className="container-page">
        <div className="rounded-2xl border border-dashed border-olive/30 bg-olive-light/30 p-8">
          <div className="text-[10px] font-mono uppercase tracking-[0.22em] text-olive/70">
            block · {blockType}
          </div>
          <h3 className="mt-2 font-display text-2xl text-olive-deep">{title}</h3>
          {data.subheading || data.lead || data.description ? (
            <p className="mt-2 text-ink/70 leading-relaxed">
              {data.subheading || data.lead || data.description}
            </p>
          ) : null}
        </div>
      </div>
    </section>
  );
}

export default StubBlock;
